import {Injectable, signal, computed, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';
import {AdsRestService} from '../api/cms/ads.rest-service';
import {timer} from "rxjs";
import {tap} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class AdsService {
    private _isLoading = signal(false);
    readonly isLoading = this._isLoading.asReadonly();
    private _ads = signal<any>({ content: [] });
    readonly ads = this._ads.asReadonly();

    _statusNotification = signal<{ status: 'idle' | 'success' | 'error', message?: string }>({ status: 'idle' });
    readonly statusNotification = this._statusNotification.asReadonly();

    showNotification = computed(() => {
        return this._statusNotification().status !== 'idle';
    });

    readonly  locations = signal([
        {value: 'STICKY_BANNER', label: 'Sticky Banner'},
        {value: 'RIGHT', label: 'Rechts Skyscraper Banner'},
        {value: 'LEFT', label: 'Links Skyscraper Banner'},
        {value: 'FEATURED_BANNER', label: 'Featured Banner'},
        {value: 'INVOICE_BANNER', label: 'Belegsuche Footer Banner'},
        {value: 'PRODUCT_SEARCH', label: 'Produktsuche Banner'},
        {value: 'EMAIL_BANNER', label: 'Email Banner'},
        {value: 'DASH', label: 'Super Banner'},
        {value: 'PROMO', label: 'Promotions Banner'},
        {value: 'MENU', label: 'Square Banner'},
    ]);

    protected adsRestService: AdsRestService = inject(AdsRestService);
    private readonly destroyRef = inject(DestroyRef);

    getAds(page, size, filter: string, sort: any, company?, location?, status?) {
        this._isLoading.set(true);
        this.adsRestService.loadAllAds(page, size, filter, sort, company, location, status)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (ads: any) => {
                    this._ads.set(ads.return_object);
                    this._isLoading.set(false);
                },
                error: (error: any) => {
                    console.error('error', error);
                    this._isLoading.set(false);
                }
            });
    }

    deleteAd(adId: any) {
        this._isLoading.set(true);
        return this.adsRestService.deleteAd(adId)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap({
                    next: () => {
                        this._isLoading.set(false);
                        this._statusNotification.set({ status: 'success', message: 'Delete successful' });
                        timer(5000)
                            .pipe(takeUntilDestroyed(this.destroyRef))
                            .subscribe(() => {
                                this._statusNotification.set({ status: 'idle' });
                            });
                    },
                    error: (error: any) => {
                        console.error('error', error);
                        this._isLoading.set(false);
                        this._statusNotification.set({ status: 'error', message: 'Oops!' });
                        timer(5000)
                            .pipe(takeUntilDestroyed(this.destroyRef))
                            .subscribe(() => {
                                this._statusNotification.set({ status: 'idle' });
                            });
                    }
                })
            );
    }

    saveAd(adData: any) {
        this._isLoading.set(true);
        return this.adsRestService.saveAd(adData)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap({
                    next: () => {
                        this._isLoading.set(false);
                        this._statusNotification.set({
                            status: 'success',
                            message: 'Banner Ad erfolgreich gespeichert!'
                        });
                        timer(5000)
                            .pipe(takeUntilDestroyed(this.destroyRef))
                            .subscribe(() => {
                                this._statusNotification.set({ status: 'idle' });
                            });
                    },
                    error: (error: any) => {
                        console.error('error', error);
                        this._isLoading.set(false);
                        this._statusNotification.set({
                            status: 'error',
                            message: 'Fehler beim Erstellen!'
                        });
                        timer(5000)
                            .pipe(takeUntilDestroyed(this.destroyRef))
                            .subscribe(() => {
                                this._statusNotification.set({ status: 'idle' });
                            });
                    }
                })
            );
    }
}
